
(function(duo) {
  'use strict';

  class TogglePanel {
    constructor(settings) {
      this.defaultSettings = {
        panel: undefined,
        triggers: undefined,
        closeOnResize: true,
        closeOnBodyClick: true,
        hover: false
        // mobileTouch: true,
        // desktopHover: false,
        // breakpoint: 1024,
      };

      try {
        this.settings = Object.assign({}, this.defaultSettings, settings);
        this.setEvents();
      } catch(err) {
        console.error(err);
      }
    }

    setEvents() {
      const _this = this;
      /* set click event on the triggers */

      let eventListener = _this.hover ? 'hover' : 'click';

      _this.settings.triggers.forEach(trigger => {
        trigger.addEventListener(eventListener, (ev) => {
          ev.preventDefault();
          _this.togglePanel();
        });
      });

      /* window resize, close panel */
      if (_this.settings.closeOnResize > 0) {
        window.addEventListener('resize', (event) => {
          if (_this.settings.panel.hasAttribute('open')) {
            _this.closePanel();
          }
        });
      }

      /* click outside the panel, close panel */
      if (_this.settings.closeOnBodyClick) {
        document.body.addEventListener('click', (ev) => {
          const target = ev.target;
          const clickedInside = _this.settings.panel.contains(ev.target);

          if (!clickedInside) {
            if (_this.settings.panel.hasAttribute('open')) {
              _this.closePanel();
            }
          }
        });
      }
    }

    openPanel() {
      /**
       * Create and dispatch custom event start:open on panel beore opening animation
       * set animate-open attribute on panel
       * at end of animation remove animate-open attribute, and add open attribute
       * Create and dispatch custom event is:open on panel when animation done
       *  */
      const _panel = this.settings.panel;

      const ceObj = {'panel': _panel, 'triggers': this.settings.triggers};
      const customEvent = new CustomEvent('start:open', {detail: ceObj});
      _panel.dispatchEvent(customEvent);

      _panel.removeAttribute('closed');
      _panel.setAttribute('animate-open', '');

      _panel.addEventListener(
        'animationend', () => {
          _panel.setAttribute('open', '');
          _panel.removeAttribute('animate-open');

          const customEvent = new CustomEvent('is:open', {detail: ceObj});
          _panel.dispatchEvent(customEvent);
        }, { once: true }
      );

      this.setTriggersAriaExpanded(true);
    }

    closePanel() {
      /**
       * Create and dispatch custom event start:close on panel beore closing animation
       * set animate-closing attribute on panel
       * at end of animation remove animate-closing attribute, and add closed attribute
       * Create and dispatch custom event is:closed on panel when animation done
       *  */
      const _panel = this.settings.panel;

      const ceObj = {'panel': _panel, 'triggers': this.settings.triggers};
      const customEvent = new CustomEvent('start:close', {detail: ceObj});
      _panel.dispatchEvent(customEvent);

      _panel.setAttribute('animate-closing', '');

      _panel.removeAttribute('open');
      _panel.addEventListener(
        'animationend', () => {
          _panel.setAttribute('closed', '');
          _panel.removeAttribute('animate-closing');

          const customEvent = new CustomEvent('is:closed', {detail: ceObj});
          _panel.dispatchEvent(customEvent);
        }, { once: true }
      );

      this.setTriggersAriaExpanded(false);
    }

    togglePanel() {
      /**
       * Check the status of the panel
       *  */
      if (!this.settings.panel.hasAttribute('open')) {
        this.openPanel();
      } else {
        this.closePanel();
      }
    }

    setTriggersAriaExpanded(status) {
      /**
       * toggle the aria-expanded status on the triggers
       *  */
      this.settings.triggers.forEach(trigger => {
        trigger.setAttribute('aria-expanded', status);
      });
    }
  }

  duo.TogglePanel = TogglePanel;

})(window.duo = window.duo || {});
